// vue
import { useStore } from '@/store';

// hooks
import { useAxios } from '@/vue3/hooks/axiosHook';

export const useSpectatorNavlinkConfigService = () => {
    // hooks
    const { apiUrl } = useStore().state;
    const axios = useAxios();

    // reactive

    // methods
    const getAllSpectatorNavlinkConfigs = async (): Promise<any[]> => {
        const res = await axios.get(`${apiUrl}/spectator-navlink/config/all`);
        return res.data;
    };

    const getSpectatorNavlinkConfigById = async (id: number): Promise<any> => {
        const res = await axios.get(`${apiUrl}/spectator-navlink/config/${id}`);
        return res.data;
    };

    const createSpectatorNavlinkConfig = async (config_data: any): Promise<any> => {
        const res = await axios.post(`${apiUrl}/spectator-navlink/config`, config_data);
        return res.data;
    };

    const updateSpectatorNavlinkConfig = async (config_data: any): Promise<any> => {
        const res = await axios.put(`${apiUrl}/spectator-navlink/config`, config_data);
        return res.data;
    };

    const deleteSpectatorNavlinkConfig = async (id: number) => {
        const res = await axios.deleteId(`${apiUrl}/spectator-navlink/config/${id}`);
        return res.status;
    };

    const getSpectatorNavlinkCourseData = async (id: number): Promise<any> => {
        const res = await axios.get(`${apiUrl}/spectator-navlink/course-data/${id}`);
        return res.data;
    };

    const createSpectatorNavlinkCourseData = async (course_data: any): Promise<any> => {
        const res = await axios.post(`${apiUrl}/spectator-navlink/course-data`, course_data);
        return res.data;
    };

    const updateSpectatorNavlinkCourseData = async (course_data: any): Promise<any> => {
        const res = await axios.put(`${apiUrl}/spectator-navlink/course-data`, course_data);
        return res.data;
    };

    const deleteSpectatorNavlinkCourseData = async (id: number) => {
        const res = await axios.deleteId(`${apiUrl}/spectator-navlink/course-data/${id}`);
        return res.status;
    };



    return {
        getAllSpectatorNavlinkConfigs,
        getSpectatorNavlinkConfigById,
        createSpectatorNavlinkConfig,
        updateSpectatorNavlinkConfig,
        deleteSpectatorNavlinkConfig,
        getSpectatorNavlinkCourseData,
        createSpectatorNavlinkCourseData,
        updateSpectatorNavlinkCourseData,
        deleteSpectatorNavlinkCourseData
    };
};
